import React from 'react';
import Button from '../../../components/base/Button';

export default function AppHeroSection() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div className="space-y-8">
            <div>
              <div className="inline-flex items-center space-x-2 bg-[#12B6B6]/10 rounded-full px-4 py-2 mb-6">
                <i className="ri-smartphone-line text-[#12B6B6]"></i>
                <span className="text-sm font-medium text-[#12B6B6]">Coming Soon</span>
              </div>
              
              <h1 className="text-5xl md:text-6xl font-bold text-[#111111] leading-tight mb-6">
                OxyAI™ –
                <br />
                <span className="text-[#12B6B6]">Your Oxygen Score</span>
                <br />
                in 90 Seconds.
              </h1>
              
              <p className="text-xl text-gray-700 leading-relaxed mb-4">
                OxyAI™ is our AI-powered oxygen screening experience that helps individuals understand their oxygen deficiency risk quickly and simply. By answering a short guided questionnaire, users receive a personalized oxygen risk score along with practical insights and next steps.
              </p>

              <p className="text-sm text-gray-500 italic border-l-2 border-[#12B6B6] pl-3 mb-8">
                OxyAI is designed for awareness and preventive guidance and does not replace professional medical evaluation.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <Button variant="primary" size="lg" className="px-8">
                Join Waitlist
              </Button>
              <Button variant="outline" size="lg" className="px-8">
                Watch Demo
              </Button>
            </div>

            {/* Quick Stats */}
            <div className="grid grid-cols-3 gap-8 pt-8">
              <div>
                <div className="text-2xl font-bold text-[#12B6B6]">90s</div>
                <div className="text-sm text-gray-600">Assessment Time</div>
              </div>
              <div>
                <div className="text-2xl font-bold text-[#12B6B6]">AI-Powered</div>
                <div className="text-sm text-gray-600">Analysis</div>
              </div>
              <div>
                <div className="text-2xl font-bold text-[#12B6B6]">Privacy First</div>
                <div className="text-sm text-gray-600">Your Data Protected</div>
              </div>
            </div>
          </div>

          {/* Right - Phone Mockup */}
          <div className="relative">
            <div className="relative mx-auto w-80 h-[600px]">
              {/* Phone Frame */}
              <div className="absolute inset-0 bg-gray-900 rounded-[3rem] p-2">
                <div className="w-full h-full bg-white rounded-[2.5rem] overflow-hidden relative">
                  {/* Notch */}
                  <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-32 h-6 bg-gray-900 rounded-b-xl z-10"></div>
                  
                  {/* Screen Content */}
                  <div 
                    className="w-full h-full relative"
                    style={{
                      backgroundImage: `url('https://static.readdy.ai/image/9842b5143901a0019f067b22648287f2/e02ccdad9401b4ae7d91a47c24564639.png')`,
                      backgroundSize: 'contain',
                      backgroundPosition: 'center',
                      backgroundRepeat: 'no-repeat',
                    }}
                  >
                    <div className="absolute inset-0 bg-gradient-to-b from-white/90 to-white/80 flex flex-col justify-center items-center p-8 text-center">
                      <div className="w-16 h-16 bg-[#12B6B6] rounded-full flex items-center justify-center mb-4">
                        <i className="ri-heart-pulse-line text-2xl text-white"></i>
                      </div>
                      <h3 className="text-lg font-bold text-[#111111] mb-2">OxyAI™</h3>
                      <p className="text-sm text-gray-600 mb-6">Your Oxygen Health Assistant</p>
                      <div className="w-full bg-gray-200 rounded-full h-2 mb-4">
                        <div className="bg-[#12B6B6] h-2 rounded-full w-2/3"></div>
                      </div>
                      <p className="text-xs text-gray-500">Assessment in progress...</p>
                    </div>
                  </div>
                </div>
              </div>
              
              {/* Floating Elements */}
              <div className="absolute -top-4 -right-4 bg-white rounded-2xl p-4 shadow-lg">
                <div className="flex items-center space-x-2">
                  <div className="w-3 h-3 bg-green-500 rounded-full"></div>
                  <span className="text-xs font-medium">Online</span>
                </div>
              </div>
              
              <div className="absolute -bottom-4 -left-4 bg-white rounded-2xl p-4 shadow-lg">
                <div className="text-center">
                  <div className="text-lg font-bold text-[#12B6B6]">85</div>
                  <div className="text-xs text-gray-600">OxyScore™</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
